module.exports = __webpack_public_path__ + "media/post-listing-block-2-image.bd8fdad2.webp";